import { cls } from "@wss/cls";
import React, { ComponentProps } from "react";

type ProductDetailHeadingItemNumberProps = ComponentProps<"p"> & {
  itemNumber: string;
  showVendorItemNumber: boolean;
  actualVendorItemNumber: string;
};

const ProductDetailHeadingItemNumber = ({
  itemNumber,
  showVendorItemNumber,
  actualVendorItemNumber,
  className,
  ...rest
}: ProductDetailHeadingItemNumberProps) => {
  return (
    <p className={cls("m-0 text-xs", className)} {...rest}>
      <span className="mr-2">
        <span className="sr-only">Item number&nbsp; </span>
        <span aria-hidden="true">Item #:&nbsp;</span>
        <span className="uppercase">{itemNumber}</span>
      </span>
      {showVendorItemNumber && actualVendorItemNumber && (
        <span
          className="mr-2"
          data-testid="product-detail-heading-vendor-number"
        >
          <span className="sr-only">MFR number&nbsp; </span>
          <span aria-hidden="true">MFR #:&nbsp;</span>
          <span className="uppercase">{actualVendorItemNumber}</span>
        </span>
      )}
    </p>
  );
};

export default ProductDetailHeadingItemNumber;
